import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { AutoCarousel } from "@components/media/AutoCarousel"
import { Breadcrumbs } from "@components/page/Breadcrumbs"
import { Chip } from "@components/ui/Chip"
import { tv } from "@utils/tw"
import { defineBlock, EditableText, usePostExcerptEditor, usePostTitleEditor } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Program Strand",
  description: "A collection of films, as part of the SFF program",
  icon: "tag",
  flags: {
    fullWidth: true,
  },
  postMetaBlock: {
    postTypes: ["strand"],
    fieldName: "info",
  },
}

export default defineBlock("strand/strand-header", (props) => {
  const headerStyles = createHeaderStyles({
    // Always just dark in 2026
    theme: "dark",
  })

  return (
    <div className="theme-dark bg-bg text-fg">
      {/* Breadcrumbs, if there are any */}
      {!!props.strand?.breadcrumbs?.length && <Breadcrumbs breadcrumbs={props.strand.breadcrumbs} />}
      {/* Header */}
      <div className={headerStyles.base()}>
        <div className={headerStyles.media()}>
          <AutoCarousel
            aspect={16 / 9}
            speed={0.1}
            items={
              props.strand?.images?.map((img) => (
                <div className="flex pr-3 h-full">
                  <ResponsiveImage srcSet={img.srcSet} objectFit="cover" className="w-full h-full" />
                </div>
              ))!
            }
          />
        </div>
        <div className={headerStyles.info()}>
          <EditableText
            as="h1"
            store={usePostTitleEditor(props.strand?.title!)}
            className="type-title-xl md:type-title-l mb-8"
          />
          <div className="flex-1" />
          <div className="flex gap-2 md:gap-3">
            <Chip>Program Strand</Chip>
            {props.category?.name && <Chip>{props.category?.name}</Chip>}
          </div>
          <EditableText
            as="p"
            store={usePostExcerptEditor(props.strand?.excerpt!)}
            className="type-body-l mt-4 max-w-[30em] text-pretty"
            allowedFormats={["core/italic"]}
          />
        </div>
      </div>
    </div>
  )
})

const createHeaderStyles = tv({
  base: "w-full flex flex-col md:flex-row",
  slots: {
    media: "bg-bg theme-dark text-fg md:flex-1 md:order-1 h-[40vw] md:h-[30vw] max-h-[600px] relative",
    info: "flex-none flex flex-col mx-grid-margin md:ml-grid-margin-full pr-grid-margin md:w-cols-5 py-7 md:py-6",
  },
  variants: {
    theme: {
      orange: "bg-orange",
      coral: "bg-coral",
      blue: "bg-blue",
      green: "bg-green",
      lavender: "bg-lavender",
      dark: "",
    },
  },
})
